import {
  Component,
  Element,
  h,
  Listen,
  Method,
  Prop,
  State,
  Watch,
} from "@stencil/core";
import { Content, EMPTY_CONTENT } from "@phn/entities/content";
import { navContentStore } from "@phn/state/nav-content-store";
import {
  navStateDefaultData,
  navStateStore,
  NavStateType,
} from "@phn/state/nav-state-store";
import {
  goTo,
  mountRouteFromString,
  reset,
} from "@phn/services/routing-manager";
import { loadRootElement } from "@phn/utility/helper";
import animationManager from "@phn/services/animation-manager";
import windowService from "@phn/services/window-service";
import { routerStore } from "@phn/state/router-store";
import {
  shopStateStore,
  ShopStateStoreTypes,
  shopStoreDefaultData,
} from "@phn/state/shop-state-store";
import {
  finderStateStore,
  FinderStateStoreTypes,
  finderStoreDefaultData,
} from "@phn/state/finder-state-store";
import { loadSavedDealerSearchResults } from "@phn/services/dealer-store-service";
import logger from "@phn/services/logger";

@Component({
  tag: "phn-nd-navigation-drawer-initiater",
})
export class NavigationDrawerInitiater {
  @Prop() navContent: Content;

  @Prop() navStateContent: NavStateType;

  @Prop() shopStoreContent: ShopStateStoreTypes;

  @Prop() finderStoreContent: FinderStateStoreTypes;

  @Element() el!: HTMLPhnNdNavigationDrawerInitiaterElement;

  @State() isDrawerOpened = false;

  componentWillLoad() {
    navContentStore.state = this.navContent || EMPTY_CONTENT;
    navStateStore.state = this.navStateContent || navStateDefaultData;
    shopStateStore.state = this.shopStoreContent || shopStoreDefaultData;
    finderStateStore.state = this.finderStoreContent || finderStoreDefaultData;

    loadRootElement(this.el);
    animationManager.initialize();

    loadSavedDealerSearchResults();
  }

  componentDidLoad(): void {
    try {
      this.checkMarketingConsent();
    } catch (err) {
      logger.error("INIT_COOKIE_CONSENT", err as Error);
    }
  }

  @Listen("ucInit", { target: "window", passive: true })
  handleUserCentricInitialization(): void {
    try {
      this.checkMarketingConsent();
    } catch (err) {
      logger.error("INIT_COOKIE_CONSENT", err as Error);
    }
  }

  private checkMarketingConsent() {
    windowService.maybeCheckMarketingConsent();
  }

  @Watch("navContent")
  watchNavContent(newValue: Content) {
    navContentStore.state = newValue;
  }

  @Watch("navStateContent")
  watchNavState(newValue: NavStateType) {
    navStateStore.state = { ...navStateStore.state, ...newValue };
  }

  @Watch("shopStoreContent")
  watchShopState(newValue: ShopStateStoreTypes) {
    shopStateStore.state = newValue;
  }

  @Watch("finderStoreContent")
  watchFinderState(newValue: FinderStateStoreTypes) {
    finderStateStore.state = newValue;
  }

  @Listen("resize", { target: "window", passive: true })
  resizeHandler(): void {
    routerStore.state.breakpoint = windowService.getBreakpoint();
  }

  @Listen("keydown", { target: "window", passive: true })
  handleKeyDown(e: KeyboardEvent): void {
    if (e.key === "Escape" && this.isDrawerOpened) {
      this.closeDrawer();
      return;
    }
  }

  @Method()
  openDrawer(initialRoutingKeys: string) {
    this.isDrawerOpened = true;
    goTo(...mountRouteFromString(initialRoutingKeys));
  }

  @Method()
  closeDrawer() {
    this.isDrawerOpened = false;
    reset();
  }

  render() {
    return <phn-nd-drawer-selector />;
  }
}
